import { render, staticRenderFns } from "./SampleListItem.vue?vue&type=template&id=09ca0cc0&scoped=true"
import script from "./SampleListItem.vue?vue&type=script&lang=ts"
export * from "./SampleListItem.vue?vue&type=script&lang=ts"
import style0 from "./SampleListItem.vue?vue&type=style&index=0&id=09ca0cc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ca0cc0",
  null
  
)

export default component.exports